import { StepProvider } from './StepContext';

//Components
import BookingWizard from './BookingWizard';

//Global state
import { useGlobal } from '../../Core/GlobalState/Store';

export default function SelfStorageForm() {
  const { currentLocation, room, user, date, sessionId, selectedSize } =
    useGlobal();

  // This array defines the conditions for proceeding to the next step in the booking wizard.
  // each function can control the flow.
  const canProceed = [
    () => true, // Step 0: Location (auto-advances)
    () => !!selectedSize, // Step 1: Size selection
    () => !!currentLocation && date !== null, // Step 2: Booking date
    () => room !== null, // Step 3: User details
    () => user !== null, // Step 4: Confirmation, and user verification for checkout
    () => user !== null, // Step 5: Checkout
  ];

  return (
    <StepProvider
      initialStep={currentLocation ? 1 : 0}
      canProceed={canProceed}
      totalSteps={6}
    >
      <BookingWizard sessionId={sessionId} />
    </StepProvider>
  );
}
